import { Component, ContentChild, EventEmitter, Input, Output, TemplateRef } from '@angular/core';
import { ComponentView } from 'src/modules/app-template/models/component-view.model';
import { TableData } from 'src/modules/sm-base/models/table-data.model';
import { TableRow } from 'src/modules/sm-base/models/table-row.model';
import { Strings } from 'src/modules/utils/shared/strings';
import { RestEndpoint } from '../../models/rest-endpoint.model';
import { TableRowEvent } from '../../models/table-row-event.model';

@Component({
    selector: 'crud-list',
    templateUrl: './crud-list.component.html',
    styleUrls: ['./crud-list.component.scss'],
    standalone: false
})
export class CrudListComponent extends ComponentView {

    @Input()
    data: TableData;
    @Input()
    detailUrl: string;
    @Input()
    restUrl: string;
    @Input()
    allowCreate = true;
    @Input()
    allowDelete = true;
    @ContentChild("toolbarTemplate", {static: true})
    toolbarTemplate?: TemplateRef<any>;
    @Output()
    onDelete = new EventEmitter<TableRow>();

    async rowSelect(row: TableRow): Promise<void> {
        await this.app.navigateToUrl(Strings.ensureSuffix(this.detailUrl, "/") + row.raw.id);
    }

    async deleteObject(evt: TableRowEvent): Promise<void> {
        if ((await this.app.deleteDataHandler<string>(async () => RestEndpoint.main().query({id: evt.row.raw.id}).delete().run(this.restUrl).getText(), this, true))[0]) {
            this.onDelete.emit(evt.row);
        }
    }
}
